<template>
  <div>
    <vs-table stripe :multiple="false" v-model="selected" :sst="true" :max-items="50" :data="list" @sort="handleSort">
      <div class="flex items-center justify-between w-full" slot="header">
        <div v-if="$store.state.route.query.search">
          <h3>aranan: {{ $store.state.route.query.search }}</h3>
        </div>
        <div v-if="topic">
          <h3 class="text-lg max-w-md font-bold">
            {{ topic.topic }}
          </h3>
        </div>
        <div class="con-input-search vs-table--search">
          <input v-model="search" v-on:keyup.enter="handleSearch" class="input-search vs-table--search-input" type="text" />
          <vs-icon icon="search"></vs-icon>
        </div>
      </div>
      <template slot="thead">
        <vs-th sort-key="order_status">Durum</vs-th>
        <vs-th sort-key="topic">Diolar</vs-th>
        <vs-th sort-key="createDate">Yaratılma Tarihi</vs-th>
        <vs-th sort-key="updateDate">Güncellenme Tarihi</vs-th>
        <vs-th sort-key="publishDate">Yayınlanma Tarihi</vs-th>
        <vs-th>Aksiyon</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td id="status">
              <vs-chip :color="statesType[tr.state]" class="product-order-status">{{ stateTexts[tr.state] }}</vs-chip>
            </vs-td>

            <vs-td id="dio">
              <div id="dio-title" v-if="!topic && tr.topic">
                <strong id="entrytopic">
                  {{ tr.topic.topic }}
                </strong>
              </div>
              <div id="entryhtml" class="mt-3 break-all" v-html="$sanitize(tr.entry.entryData)"></div>
              <div class="flex break-all my-2 flex-wrap w-full max-w-sm" v-if="tr.entry.entryImageUrls && tr.entry.entryImageUrls.length">
                <div v-for="(img, index) in tr.entry.entryImageUrls" :key="index" class="w-1/5">
                  <img :src="getImageUrl(img, '75x75')" class="rounded image-entry pl-0 p-2" />
                </div>
              </div>
            </vs-td>
            <vs-td id="createDate">
              <p class="w-24 font-medium">
                {{ tr.createDate | moment('DD-MM-YYYY') }}
                <br />
                {{ tr.createDate | moment('HH:mm') }}
              </p>
            </vs-td>

            <vs-td id="updateDate">
              <p class="w-24 font-medium">
                {{ tr.updateDate | moment('DD-MM-YYYY') }}
                <br />
                {{ tr.updateDate | moment('HH:mm') }}
              </p>
            </vs-td>

            <vs-td id="publishDate">
              <p class="w-24 font-medium" v-if="tr.publishDate">
                {{ tr.publishDate | moment('DD-MM-YYYY') }}
                <br />
                {{ tr.publishDate | moment('HH:mm') }}
              </p>
              <p>-</p>
            </vs-td>

            <vs-td>
              <div class="flex justify-end">
                <vx-tooltip text="Düzenle">
                  <vs-button @click="editEntry" color="secondary" class="ml-2" type="gradient" icon="edit"></vs-button>
                </vx-tooltip>

                <vx-tooltip text="Geri Getir">
                  <vs-button
                    @click="restoreEntryById($event, tr.id)"
                    class="ml-2"
                    type="gradient"
                    color="warning"
                    icon="settings_backup_restore"
                    v-if="tr.state.includes('deleted')"
                  ></vs-button>
                </vx-tooltip>

                <vx-tooltip text="Sil">
                  <vs-button
                    class="ml-2"
                    v-if="!tr.state.includes('deleted')"
                    @click="deleteEntryById($event, tr.id)"
                    vs-type="flat"
                    color="danger"
                    icon="delete"
                  ></vs-button>
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <div v-if="true" class="con-pagination-table vs-table--pagination">
      <vs-pagination :total="getTotalPages" :sizeArray="list.length" :maxItems="pagination.maxItems" v-model="page"></vs-pagination>
    </div>
    <popup-update-entry :is-active="showUpdateDialog" @close="showUpdateDialog = false" :entry="selected"></popup-update-entry>
  </div>
</template>

<script>
import PopupUpdateEntry from '@/components/entry/PopupUpdateEntry.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { generateImageUrl } from '@/utils/imageHash';
export default {
  props: ['list'],
  components: { PopupUpdateEntry },
  data: () => ({
    search: '',
    selected: [],
    showUpdateDialog: false,
    statesType: {
      deleted: 'danger',
      waiting: 'warning',
      approved: 'success',
      restored: 'light'
    },
    stateTexts: {
      deleted: 'Silinmiş',
      waiting: 'Bekleyen',
      approved: 'Onaylanmış',
      restored: 'Geri Getirilmiş'
    }
  }),
  created() {
    this.search = this.$store.state.route.query.search || '';
  },
  watch: {
    search(val) {
      const query = this.$store.state.route.query;
      delete query.tab;
      if (val.length === 0 && this.$store.state.route.query.hasOwnProperty('search')) {
        this.$router.replace({ query: { ...query, page: 1 } });
      }
    }
  },
  computed: {
    ...mapGetters('entry', ['topic', 'pagination']),
    getTotalPages() {
      return Math.ceil(this.pagination.total / this.pagination.perPage);
    },
    page: {
      get() {
        var page = this.$route.query.page ? parseInt(this.$route.query.page) : 1;
        return page;
      },
      set(page) {
        if (page !== this.page) {
          const query = this.$route.query;
          this.setPagination({ page });
          this.$router.replace({ query: { ...query, page } });
        }
      }
    }
  },
  methods: {
    ...mapMutations('entry', ['setPagination']),
    ...mapActions('entry', ['approveEntry', 'deleteEntry', 'restoreEntry']),
    async deleteEntryById($event, id) {
      event.stopPropagation();
      if (confirm('Silmek istediğinize emin misiniz?')) {
        this.$vs.loading();
        await this.deleteEntry(id);
        this.$vs.loading.close();
        this.$vs.notify({
          color: 'success',
          text: 'Entry Silindi.'
        });
      }
    },
    async restoreEntryById($event, id) {
      event.stopPropagation();
      if (confirm('Geri getirmek istediğinize emin misiniz?')) {
        this.$vs.loading();
        await this.restoreEntry([id]);
        this.$vs.loading.close();
        this.$vs.notify({
          color: 'success',
          text: 'Entry Geri Getirildi.'
        });
      }
    },
    async handleSearch() {
      const query = this.$store.state.route.query;
      const text = this.search;
      const oldVal = query.search;
      if (text === oldVal) {
        return;
      }
      if (text.length !== 0 && text.length >= 3) {
        this.$router.replace({ query: { ...query, search: text, page: 1 } });
      } else {
        this.$vs.notify({
          text: 'Minumum 3 karakter girmelisiniz.',
          color: 'warning'
        });
      }
    },
    getImageUrl(image, size = '300x0') {
      let params = {
        size: size,
        type: 'png',
        quality: '80',
        imageUrl: image
      };
      var newUrl = generateImageUrl(params);
      return newUrl;
    },
    editEntry() {
      this.showUpdateDialog = true;
    },
    handleSort(key, active) {
      console.log(`ordered: ${key} ${active}\n`);
    }
  }
};
</script>
<style>
.vs-icon {
  font-size: 20px;
}
</style>
